import { cn } from '@/lib/cn';

const SIZES = {
  sm: 'size-4 border-2',
  md: 'size-8 border-[3px]',
  lg: 'size-14 border-4',
} as const;

interface SpinnerProps {
  size?: keyof typeof SIZES;
  /** Accessible name. Loading states carry no visible text any more. */
  label?: string;
  className?: string;
}

/**
 * The one loading indicator in urbania360: the same ring the urbania3d
 * showroom spins around a project's logo, so a tour embedded there hands off
 * from the showroom's spinner to ours without changing shape. The ring is
 * drawn in `currentColor` — set the colour with a `text-*` class on it or on
 * a parent (white over the viewer, ink tones in the admin).
 */
export function Spinner({ size = 'md', label = 'Cargando', className }: SpinnerProps) {
  return (
    <span
      data-slot="spinner"
      role="status"
      aria-label={label}
      className={cn(
        'inline-block shrink-0 animate-spin rounded-full border-current/20 border-t-current',
        SIZES[size],
        className,
      )}
    />
  );
}

/** A spinner centred in whatever box it's given — the page-level loading state. */
export function SpinnerBlock({ size, label, className }: SpinnerProps) {
  return (
    <div className={cn('flex items-center justify-center py-10 text-ink-3', className)}>
      <Spinner size={size} label={label} />
    </div>
  );
}
